import React from 'react'

import './index.scss'

const Section = ({ name, title, text }) => (
  <div className="section">
    <h3>{name}</h3>
    <h2>{title}</h2>
    {text && <p>{text}</p>}
  </div>
)

export default Section
